import React from 'react';
import PropTypes from 'prop-types';
import KpiCard from './KpiCard';

const KpiCardGroup = ({ cards }) => (
  <div className="o-kpi-card-group">
    {cards.map((card, index) => (
      <KpiCard key={index} {...card} />
    ))}
  </div>
);

KpiCardGroup.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      diff: PropTypes.number,
      rate: PropTypes.string,
      format: PropTypes.string,
    })
  ).isRequired,
};

export default KpiCardGroup;
